export const data=[
    {
        imgSrc:require('../../../assets/bara.png'),
        code:`import { BarChart } from "react-native-gifted-charts";
        
const App = () => {
    const barData = [{value: 15}, {value: 30}, {value: 26}, {value: 40}];
    return <BarChart data={barData}/>;
};`
    },
    //1
    {
        imgSrc:require('../../../assets/barb.png'),
        code:`import { BarChart } from "react-native-gifted-charts";
        
const App = () => {
    const barData = [{value: 15}, {value: 30}, {value: 26}, {value: 40}];
    return (
        <BarChart
        frontColor={'#177AD5'}
        barWidth={22}
        data={barData}
        />
    );
};`
    },
    //2
    {
        imgSrc:require('../../../assets/blueBars.png'),
        code:`import { BarChart } from "react-native-gifted-charts";
        
const App = () => {
    const barData = [
        {value: 250, label: 'M'},
        {value: 500, label: 'T', frontColor: '#177AD5'},
        {value: 745, label: 'W', frontColor: '#177AD5'},
        {value: 320, label: 'T'},
        {value: 600, label: 'F', frontColor: '#177AD5'},
        {value: 256, label: 'S'},
        {value: 300, label: 'S'},
    ];
    return (
        <View>
            <BarChart
                barWidth={22}
                noOfSections={3}
                barBorderRadius={4}
                frontColor="lightgray"
                data={barData}
                yAxisThickness={0}
                xAxisThickness={0}
            />
        </View>
    );
};`
    //3
    },
    {
      imgSrc:require('../../../assets/topLabel.png'),
      code:`import React from 'react';
import {View, Text} from 'react-native';
import {BarChart} from 'react-native-gifted-charts';

const App = () => {
  const data = [
    {value: 20, label: 'M'},
    {value: 30, label: 'T'},
    {
      value: 50,
      label: 'W',
      topLabelComponent: () => (
        <Text style={{color: 'blue', fontSize: 18, marginBottom: 6}}>50</Text>
      ),
    },
    {value: 40, label: 'T'},
    {value: 30, label: 'F'},
  ];
  return (
    <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
      <BarChart width={300} data={data} frontColor="#177AD5" />
    </View>
  );
};

export default App;
      `
    },
    //4
    {
        imgSrc:require('../../../assets/gradBars.png'),
        code:`import { BarChart } from "react-native-gifted-charts";
        
const App = () => {
    const barData = [
        {value: 0.7, label: '1'},
        {value: 0.8, label: '2'},
        {value: 0.6, label: '3'},
        {value: 0.4, label: '4'},
        {value: 0.9, label: '5'},
        {value: 0.7, label: '6'},
    ];
    return (
        <View>
        <BarChart
            showFractionalValues
            showYAxisIndices
            showXAxisIndices
            hideRules
            noOfSections={5}
            data={barData}
            showGradient
            frontColor={'#1B6BB0'}
            gradientColor={'#FFEEFE'}
            backgroundColor={'#FECF9E'}
        />
        </View>
    );
};`
    },
    //5
    {
        imgSrc:require('../../../assets/simpleThreeD.png'),
        code:`import { BarChart } from "react-native-gifted-charts";

const App = () => {
    const barData = [{value: 20}, {value: 18}, {value: 40}, {value: 60}];
    return (
        <View>
            <BarChart data={barData} isThreeD />
        </View>
    );
}
`
    },
    //6
    {
        imgSrc:require('../../../assets/barthreed.png'),
        code:`import { BarChart } from "react-native-gifted-charts";

const App = () => {
    const barData = [
        {
          value: 230,
          label: 'Jan',
          frontColor: '#4ABFF4',
          sideColor: '#23A7F3',
          topColor: '#92e6f6',
        },
        {
          value: 180,
          label: 'Feb',
          frontColor: '#79C3DB',
          sideColor: '#68BCD7',
          topColor: '#9FD4E5',
        },
        {
          value: 195,
          label: 'Mar',
          frontColor: '#28B2B3',
          sideColor: '#0FAAAB',
          topColor: '#66C9C9',
        },
        {
          value: 250,
          label: 'Apr',
          frontColor: '#4ADDBA',
          sideColor: '#36D9B2',
          topColor: '#7DE7CE',
        },
        {
          value: 320,
          label: 'May',
          frontColor: '#91E3E3',
          sideColor: '#85E0E0',
          topColor: '#B0EAEB',
        },
    return (
        <View>
            <BarChart
            showFractionalValue
            showYAxisIndices
            hideRules
            noOfSections={4}
            maxValue={400}
            data={barData}
            barWidth={40}
            sideWidth={15}
            isThreeD 
            side="right"
            />
        </View>
    );
}
`
    },
    //7
    {
        imgSrc:null,
        code:`import { BarChart } from "react-native-gifted-charts";

const App = () => {
    const barData = [
    {value: 230,label: 'Jan',frontColor: '#4ABFF4'},
    {value: 180,label: 'Feb',frontColor: '#79C3DB'},
    {value: 195,label: 'Mar',frontColor: '#28B2B3'},
    {value: 250,label: 'Apr',frontColor: '#4ADDBA'},
    {value: 320,label: 'May',frontColor: '#91E3E3'},
    ];
    return (
        <View>
            <BarChart
            showFractionalValue
            showYAxisIndices
            noOfSections={4}
            maxValue={400}
            data={barData}
            isAnimated
            />
        </View>

    );
}`
    },
    //8:
    {
        imgSrc:require('../../../assets/cappedBars.png'),
        code:`import { BarChart } from "react-native-gifted-charts";
const CappedBars = () => {
    const barData = [
    {value: 15, label: 'Jan'},
    {value: 40, label: 'Feb'},
    {value: 10, label: 'Mar'},
    {value: 30, label: 'Apr'},
    ];
    return (
    <View>
        <BarChart
        data={barData}
        barWidth={35}
        cappedBars
        capColor={'rgba(78, 0, 142)'}
        capThickness={4}
        showGradient
        gradientColor={'rgba(200, 100, 244,0.8)'}
        frontColor={'rgba(219, 182, 249,0.2)'}
        />
    </View>
    );
};
`
    },
    //9
    {
        imgSrc:require('../../../assets/groupedBars.png'),
        code:`import React from 'react';
import {View, Text} from 'react-native';
import {BarChart} from 'react-native-gifted-charts';

const GroupedBars = () => {
    const barData = [
        {
          value: 40,
          label: 'Jan',
          spacing: 2,
          labelWidth: 30,
          labelTextStyle: {color: 'gray'},
          frontColor: '#177AD5',
        },
        {value: 20, frontColor: '#ED6665'},
        {
          value: 50,
          label: 'Feb',
          spacing: 2,
          labelWidth: 30,
          labelTextStyle: {color: 'gray'},
          frontColor: '#177AD5',
        },
        {value: 40, frontColor: '#ED6665'},
        {
          value: 75,
          label: 'Mar',
          spacing: 2,
          labelWidth: 30,
          labelTextStyle: {color: 'gray'},
          frontColor: '#177AD5',
        },
        {value: 25, frontColor: '#ED6665'},
        {
          value: 30,
          label: 'Apr',
          spacing: 2,
          labelWidth: 30,
          labelTextStyle: {color: 'gray'},
          frontColor: '#177AD5',
        },
        {value: 20, frontColor: '#ED6665'},
        {
          value: 60,
          label: 'May',
          spacing: 2,
          labelWidth: 30,
          labelTextStyle: {color: 'gray'},
          frontColor: '#177AD5',
        },
        {value: 40, frontColor: '#ED6665'},
        {
          value: 65,
          label: 'Jun',
          spacing: 2,
          labelWidth: 30,
          labelTextStyle: {color: 'gray'},
          frontColor: '#177AD5',
        },
        {value: 30, frontColor: '#ED6665'},
      ];

      const renderTitle = () => {
          return(
            <View style={{marginVertical: 30}}>
            <Text
              style={{
                color: 'white',
                fontSize: 20,
                fontWeight: 'bold',
                textAlign: 'center',
              }}>
              Chart title goes here
            </Text>
            <View
              style={{
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                marginTop: 24,
                backgroundColor: 'yellow',
              }}>
              <View style={{flexDirection: 'row', alignItems: 'center'}}>
                <View
                  style={{
                    height: 12,
                    width: 12,
                    borderRadius: 6,
                    backgroundColor: '#177AD5',
                    marginRight: 8,
                  }}
                />
                <Text
                  style={{
                    width: 60,
                    height: 16,
                    color: 'lightgray',
                  }}>
                  Point 01
                </Text>
              </View>
              <View style={{flexDirection: 'row', alignItems: 'center'}}>
                <View
                  style={{
                    height: 12,
                    width: 12,
                    borderRadius: 6,
                    backgroundColor: '#ED6665',
                    marginRight: 8,
                  }}
                />
                <Text
                  style={{
                    width: 60,
                    height: 16,
                    color: 'lightgray',
                  }}>
                  Point 02
                </Text>
              </View>
            </View>
          </View>
          )
      }

    return (
        <View
        style={{
          backgroundColor: '#333340',
          paddingBottom: 40,
          borderRadius: 10,
        }}>
        {renderTitle()}
        <BarChart
          data={barData}
          barWidth={8}
          spacing={24}
          roundedTop
          roundedBottom
          hideRules
          xAxisThickness={0}
          yAxisThickness={0}
          yAxisTextStyle={{color: 'gray'}}
          noOfSections={3}
          maxValue={75}
        />
      </View>
    );
};
`
    },
    //10

    {
      imgSrc:require('../../../assets/pattern.png'),
      code:`import {BarChart} from 'react-native-gifted-charts';
import {Path, Pattern} from 'react-native-svg';

const App = () => {
  const MyPattern = () => {
      return (
        <Pattern
          id="DiagonalLines"
          patternUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={60}
          height={14}
          viewBox="0 0 40 20">
          <Path
            d="M 1220 38 L 465 0"
            stroke={'white'}
            strokeWidth={1.5}
            transform={{rotation: '-16'}}
          />
        </Pattern>
      );
    };
    
    const data=[
    {
      value: 110,
      frontColor: '#4444dd',
      spacing: 8,
    },
    {value: 130},
    {
      value: 120,
      frontColor: '#4444dd',
      spacing: 8,
    },
    {value: 160},
    {
      value: 190,
      frontColor: '#4444dd',
      spacing: 8,
    }]
    
    return <BarChart
    data={data}
    barWidth={40}
    spacing={30}
    barBackgroundPattern={MyPattern}
    patternId='DiagonalLines'  />
  }`,
    },

    //11
    {
      imgSrc:require('../../../assets/pattern2.png'),
      code:`const data = [
  {
    value: 110,
    barBackgroundPattern: MyPattern,
    patternId: 'DiagonalLines',
    frontColor: '#4444dd',
    spacing: 8,
  },
  {value: 130},
  {
    value: 120,
    barBackgroundPattern: MyPattern,
    patternId: 'DiagonalLines',
    frontColor: '#4444dd',
    spacing: 8,
  },
  {value: 160},
  {
    value: 190,
    barBackgroundPattern: MyPattern,
    patternId: 'DiagonalLines',
    frontColor: '#4444dd',
    spacing: 8,
  },
]`
    },

    //12
    {
      imgSrc:require('../../../assets/pattern3.png'),
      code:`const MyPattern = () => {
  return (
    <Pattern
      id="DiagonalLines"
      patternUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
      viewBox="0 0 10 10">
      <Path
        d="M 0 0 L 7 0 L 3.5 7 z"
        fill="red"
        stroke="blue" />
    </Pattern>
  );
};`
    }

]

export const negativeBar = `import { BarChart } from "react-native-gifted-charts";

const App = () => {
  const data = [
    {value: 15, label: 'Mon'},
    {value: 30, label: 'Tue'},
    {value: -23, label: 'Wed'},
    {value: 40, label: 'Thu'},
    {value: -16, label: 'Fri'},
    {value: 40, label: 'Sat'},
  ];
  
  return <BarChart data={data} />
}`

export const chartWithReferenceLine1 = `import { BarChart } from "react-native-gifted-charts";
        
const App = () => {
  const barData = [
    {value: 250, label: 'M'},
    {value: 500, label: 'T', frontColor: '#177AD5'},
    {value: 745, label: 'W', frontColor: '#177AD5'},
    {value: 320, label: 'T'},
    {value: 600, label: 'F', frontColor: '#177AD5'},
    {value: 256, label: 'S'},
    {value: 300, label: 'S'},
  ];
  return (
    <View>
      <BarChart
        barWidth={22}
        noOfSections={3}
        barBorderRadius={4}
        frontColor="lightgray"
        data={barData}
        yAxisThickness={0}
        xAxisThickness={0}
        hideRules
        showReferenceLine1
        referenceLine1Position={420}
        referenceLine1Config={{
          color: 'gray',
          dashWidth: 2,
          dashGap: 3,
        }}
      />
    </View>
  );
};`

export const barMargin = `import { BarChart } from "react-native-gifted-charts";
        
const App = () => {
  const barData = [
    {value: 70},
    {value: 36},
    {value: 50},
    {value: 40},
    {value: 18},
    {value: 38},
  ];

  return <BarChart data={llData} barMarginBottom={20} />;
};`

export const multiBarMargin = `import { BarChart } from "react-native-gifted-charts";
        
const App = () => {
  const llData = [
    {value: 70},
    {value: 36, barMarginBottom: 30},
    {value: 50},
    {value: 40, barMarginBottom: 0},
    {value: 18, barMarginBottom: 0},
    {value: 38},
  ];

  return <BarChart data={llData} barMarginBottom={10} />;
};`

export const simpleNeonBars = `import { BarChart } from "react-native-gifted-charts";

const App = () => {
  return (
    <View
      style={{
        paddingVertical: 100,
        backgroundColor: '#3F107A',
        flex: 1,
      }}>
      <Image
      source={{
        uri: 'https://github.com/Abhinandan-Kushwaha/chart-images/blob/main/images/walls.png?raw=true',
      }}
        style={{
          position: 'absolute',
          opacity: 0.6,
          top: 32,
          height: 300,
          width: 400,
          resizeMode: 'contain',
        }}
      />
      <View style={{marginLeft: 50}}>
        <BarChart
          data={[
            {value: 20},
            {value: 40},
            {value: 30},
            {value: 50},
            {value: 40},
          ]}
          isThreeD
          isAnimated
          initialSpacing={20}
          barMarginBottom={10}
          hideYAxisText
          yAxisThickness={0}
          xAxisThickness={6}
          xAxisColor={'#c919ff'}
          frontColor={'transparent'}
          sideColor={'#ff00d0'}
          topColor={'#ff66f4'}
          barStyle={{
            borderWidth: 4,
            borderColor: '#fc84ff',
            shadowColor: '#fc84ff',
            shadowOffset: {width: 0, height: 4},
            shadowOpacity: 1,
            shadowRadius: 8,
            elevation: 10,
          }}
          hideRules
          height={120}
          barWidth={20}
        />
      </View>
    </View>
  );
}`

export const neonBars3D = `import { BarChart } from "react-native-gifted-charts";

const App = () => {
  return (
    <View
      style={{
        paddingVertical: 100,
        backgroundColor: '#3F107A',
        flex: 1,
      }}>
      <Image
        source={{
          uri: 'https://github.com/Abhinandan-Kushwaha/chart-images/blob/main/images/walls.png?raw=true',
        }}
        style={{
          position: 'absolute',
          opacity: 0.6,
          top: 32,
          height: 300,
          width: 400,
          resizeMode: 'contain',
        }}
      />
      <View style={{marginLeft: 50}}>
        <BarChart
          data={[
            {value: 20},
            {value: 40},
            {value: 30},
            {value: 50},
            {value: 40},
          ]}
          isThreeD
          initialSpacing={20}
          barMarginBottom={10}
          showGradient
          gradientColor={'#fc84ff'}
          hideYAxisText
          yAxisThickness={0}
          xAxisThickness={6}
          xAxisColor={'#c919ff'}
          frontColor={'transparent'}
          sideColor={'#ff00d0'}
          topColor={'#ff66f4'}
          barStyle={{
            borderWidth: 4,
            borderColor: '#fc84ff',
            shadowColor: '#fc84ff',
            shadowOffset: {width: 0, height: 4},
            shadowOpacity: 1,
            shadowRadius: 8,
            elevation: 10,
          }}
          hideRules
          height={120}
          barWidth={20}
        />
      </View>
    </View>
  );
}`;


export const neonBars3DWithTooltip = `import { BarChart } from "react-native-gifted-charts";

const App = () => {
  return (
    <View
      style={{
        paddingVertical: 100,
        backgroundColor: '#3F107A',
        flex: 1,
      }}>
      <Image
        source={{
          uri: 'https://github.com/Abhinandan-Kushwaha/chart-images/blob/main/images/walls.png?raw=true',
        }}
        style={{
          position: 'absolute',
          opacity: 0.6,
          top: 32,
          height: 300,
          width: 400,
          resizeMode: 'contain',
        }}
      />
      <View style={{marginLeft: 50}}>
        <BarChart
          data={[
            {value: 20},
            {value: 40},
            {value: 30},
            {value: 50},
            {value: 40},
          ]}
          isThreeD
          initialSpacing={20}
          barMarginBottom={10}
          showGradient
          gradientColor={'#fc84ff'}
          hideYAxisText
          yAxisThickness={0}
          xAxisThickness={6}
          xAxisColor={'#c919ff'}
          frontColor={'transparent'}
          sideColor={'#ff00d0'}
          topColor={'#ff66f4'}
          barStyle={{
            borderWidth: 4,
            borderColor: '#fc84ff',
            shadowColor: '#fc84ff',
            shadowOffset: {width: 0, height: 4},
            shadowOpacity: 1,
            shadowRadius: 8,
            elevation: 10,
          }}
          hideRules
          height={120}
          barWidth={20}
          isAnimated
          renderTooltip={(item, index) => {
            return (
              <View
                style={{
                  marginBottom: 20,
                  marginLeft: -6,
                  backgroundColor: '#ffcefe',
                  paddingHorizontal: 6,
                  paddingVertical: 4,
                  borderRadius: 4,
                }}>
                <Text>{item.value}</Text>
              </View>
            );
          }}
        />
      </View>
    </View>
  );
}`;

export const barLineSimple = `import { BarChart } from "react-native-gifted-charts";
        
const App = () => {
    const barData = [{value: 15}, {value: 30}, {value: 26}, {value: 40}];
    return <BarChart data={barData} showLine/>;
};`

export const beautifulCombinedBarLine = `import { BarChart } from "react-native-gifted-charts";
        
const App = () => {
  const data = [
    {value: 2500, frontColor: '#006DFF', gradientColor: '#009FFF', spacing: 6, label:'Jan'},
    {value: 2400, frontColor: '#3BE9DE', gradientColor: '#93FCF8'},

    {value: 3500, frontColor: '#006DFF', gradientColor: '#009FFF', spacing: 6, label:'Feb'},
    {value: 3000, frontColor: '#3BE9DE', gradientColor: '#93FCF8'},

    {value: 4500, frontColor: '#006DFF', gradientColor: '#009FFF', spacing: 6, label:'Mar'},
    {value: 4000, frontColor: '#3BE9DE', gradientColor: '#93FCF8'},

    {value: 5200, frontColor: '#006DFF', gradientColor: '#009FFF', spacing: 6, label:'Apr'},
    {value: 4900, frontColor: '#3BE9DE', gradientColor: '#93FCF8'},

    {value: 3000, frontColor: '#006DFF', gradientColor: '#009FFF', spacing: 6, label:'May'},
    {value: 2800, frontColor: '#3BE9DE', gradientColor: '#93FCF8'},
  ];

  return(
    <View
      style={{
        margin: 10,
        padding: 16,
        borderRadius: 20,
        backgroundColor: '#232B5D',
      }}>
      <Text style={{color: 'white', fontSize: 16, fontWeight: 'bold'}}>
        Overview
      </Text>
      <View style={{padding: 20, alignItems: 'center'}}>
        <BarChart
          data={data}
          barWidth={16}
          initialSpacing={10}
          spacing={14}
          barBorderRadius={4}
          showGradient
          yAxisThickness={0}
          xAxisType={'dashed'}
          xAxisColor={'lightgray'}
          yAxisTextStyle={{color: 'lightgray'}}
          stepValue={1000}
          maxValue={6000}
          noOfSections={6}
          yAxisLabelTexts={['0', '1k', '2k', '3k', '4k', '5k', '6k']}
          labelWidth={40}
          xAxisLabelTextStyle={{color: 'lightgray', textAlign: 'center'}}
          showLine
          lineConfig={{
            color: '#F29C6E',
            thickness: 3,
            curved: true,
            hideDataPoints: true,
            shiftY: 20,
            initialSpacing: -30,
          }}
        />
      </View>
    </View
  );`

  export const secondaryYAxisType = `secondaryYAxisType = {
    noOfSections?: number,
    maxValue?: number,
    mostNegativeValue?: number,
    stepValue?: number,
    stepHeight?: number,
    showFractionalValues?: boolean,
    roundToDigits?: number,
  
    showYAxisIndices?: boolean,
    yAxisIndicesHeight?: number,
    yAxisIndicesWidth?: number,
    yAxisIndicesColor?: ColorValue,
  
    yAxisSide?: yAxisSides,
    yAxisOffset?: number,
    yAxisThickness?: number,
    yAxisColor?: ColorValue,
    yAxisLabelContainerStyle?: any,
    yAxisLabelTexts: Array<string> | undefined,
    yAxisTextStyle?: any,
    yAxisTextNumberOfLines?: number,
    yAxisLabelWidth?: number,
    hideYAxisText?: boolean,
    yAxisLabelPrefix?: string,
    yAxisLabelSuffix?: string,
    hideOrigin?: boolean,
  }`